import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  Pagination,
  CreateButton,
  TextInput,
  type RaRecord,
  useGetOne,
} from "react-admin";

import { FILTER_LIMITS } from "@/constants/filters";
import { useTypedListContext } from "@/hooks";

import { ClientAppField } from "../../clientApps/components/ClientAppField";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const MailSubjectsList = () => {
  return (
    <List
      actions={<ListActions />}
      storeKey={false}
      filters={[
        <TextInput
          key="id"
          defaultValue=""
          label="Search report by id"
          source="id"
          alwaysOn
        />,
      ]}
      perPage={FILTER_LIMITS[0]}
      pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
    >
      <MailListDataGrid />
    </List>
  );
};

const MailListDataGrid = () => {
  const { filterValues } = useTypedListContext<RaRecord, { id?: string }>();
  const id = filterValues.id;
  const isIdFilterActive = Boolean(id);
  const mailSubjectResponse = useGetOne(
    "mail-subjects",
    { id: id ?? "" },
    { enabled: isIdFilterActive },
  );
  const data = isIdFilterActive
    ? [mailSubjectResponse.data].filter((item) => item != null)
    : undefined;

  return (
    <DatagridConfigurable
      bulkActionButtons={false}
      data={data}
      isPending={isIdFilterActive ? mailSubjectResponse.isPending : undefined}
      rowClick="edit"
    >
      <TextField source="id" sortable={false} />
      <TextField source="type" sortable={false} />
      <TextField source="title" sortable={false} />
      <ClientAppField source="clientApp" sortable={false} />
    </DatagridConfigurable>
  );
};
